/* Jellymoon: los botes flotantes de la portada (1, 2 o 3) vuelan al carrito al pulsar «Agregar al carrito» (adaptado de kfly.js de Karseell). */
(function(){
  if (window.__jmfly) return; window.__jmfly = 1;
  var busy = false, mq = window.matchMedia('(max-width: 749px)');
  function rc(e){ var r = e.getBoundingClientRect(); return { x: r.left + r.width/2, y: r.top + r.height/2, w: r.width, h: r.height, l: r.left, t: r.top }; }
  function pulse(el){ if (el && el.animate) el.animate([{transform:'scale(1)'},{transform:'scale(1.18)'},{transform:'scale(1)'}], {duration:420, easing:'ease-out'}); }
  function cartOpen(){ return !!document.querySelector('cart-drawer-component dialog[open], .cart-drawer dialog[open]'); }
  function scene(){ var s = document.querySelector('.jm-kfl'); if (!s) return null; var r = s.getBoundingClientRect(); return (r.width > 0 && r.bottom > 0 && r.top < innerHeight) ? s : null; }
  function hide(els){ els.forEach(function(e){ e.style.transition = 'none'; e.style.opacity = '0'; }); }
  function show(els){ els.forEach(function(e){ e.style.transition = 'opacity .9s ease'; e.style.opacity = ''; });
    setTimeout(function(){ els.forEach(function(e){ e.style.transition = ''; }); busy = false; }, 950); }
  function comeBack(els){ var waited = 0; (function tick(){ if (cartOpen()) waited = 0; else waited += 200; if (!cartOpen() && waited >= 1500) { show(els); return; } setTimeout(tick, 200); })(); }
  function fly(btn, go){
    var sc = scene(); if (!sc || busy || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    // vuelan todos los botes visibles (1, 2 o 3 según el selector jm-botes)
    var imgs = [].slice.call(sc.querySelectorAll('.jm-kfl__bote')).filter(function(i){ return parseFloat(getComputedStyle(i).opacity) > .5; });
    if (!imgs.length) return false;
    busy = true;
    var target = mq.matches ? btn : (document.querySelector('.header-actions__cart-icon, [data-testid="cart-icon"]') || btn); var T = rc(target);
    var els = [].slice.call(sc.querySelectorAll('.jm-kfl__bote, .jm-kfl__sombra')).filter(function(e){ return parseFloat(getComputedStyle(e).opacity) > .5; });
    var clones = imgs.map(function(img){
      var s = rc(img), k = parseFloat(getComputedStyle(img).scale) || 1;
      var w = img.offsetWidth * k, h = img.offsetHeight * k;
      var c = document.createElement('img'); c.src = img.currentSrc || img.src; c.alt = '';
      c.style.cssText = 'position:fixed;left:'+(s.x - w/2)+'px;top:'+(s.y - h/2)+'px;width:'+w+'px;height:'+h+'px;z-index:2147483000;pointer-events:none;will-change:transform,opacity;transform-origin:center center;margin:0;max-width:none;object-fit:contain';
      document.body.appendChild(c); return { c: c, s: s };
    });
    hide(els);
    var left = clones.length, up = mq.matches ? -70 : -50;
    clones.forEach(function(o, i){
      var dx = T.x - o.s.x, dy = T.y - o.s.y;
      var a = o.c.animate([
        { transform: 'translate(0,0) scale(1) rotate(-8deg)', opacity: 1 },
        { offset: .3, transform: 'translate('+(dx*.12)+'px,'+(dy*.12+up)+'px) scale(.82) rotate(-2deg)', opacity: 1 },
        { transform: 'translate('+dx+'px,'+dy+'px) scale(.08) rotate(14deg)', opacity: .25 }
      ], { duration: 950, delay: i * 140, easing: 'cubic-bezier(.6,0,.3,1)', fill: 'both' });
      a.onfinish = function(){ o.c.remove(); pulse(target); if (--left === 0) { go(); comeBack(els); } };
    });
    return true;
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.add-to-cart__button, button[name="add"], .product-form__submit');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    if (b.__jmGo) { b.__jmGo = false; return; }
    if (fly(b, function(){ b.__jmGo = true; b.click(); })) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
